import { useTranslation } from 'next-i18next'

import { usePageTitle } from '~/utils/tags'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import Metatags from '~/components/Metadata/Metatags'
import MediaPage from '~/donation/pages/Media.page'
import { GetProps } from '~/utils/pageWrapper/types'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import DonationLayout from '~/shared/layouts/DonationLayout'

const MathMagicMediaPage = (): React.ReactElement => {
  const { t } = useTranslation('donation')
  const pageTitle = usePageTitle(t('title'))

  return (
    <>
      <Metatags metaDescription={t('metaDescription')} title={pageTitle} />
      <MediaPage />
    </>
  )
}

MathMagicMediaPage.getLayout = DonationLayout

export const getProps: GetProps = () => () => {
  return {
    props: {
      namespaces: [...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES, 'donation'],
    },
  }
}

export const getStaticProps = getStaticPropsWrapper(getProps)

export default MathMagicMediaPage
